export default "__VITE_ASSET__wNkUibCB__"